class PasswordConfirmer {
  constructor() {
    this.restrict = 'A';
    this.require = 'ngModel';
    this.scope = {
      originalPassword: '=passwordConfirmer'
    };

    /**
     * Link
     * @param  {Object} scope
     * @param  {Object} element
     * @param  {Object} attrs
     * @param  {Array} requiredCtrls
     * @return {Void}
     */
    this.link = (scope, element, attrs, modelCtrl) => {
      modelCtrl.$validators.confirmPassword = (modelValue) => {
        return modelValue == scope.originalPassword || !modelValue;
      };

      scope.$watch('originalPassword', function() {
          modelCtrl.$validate();
      });
    };
  }

  /**
   * Factory
   * @return {Object}
   */
  static directiveFactory() {
    PasswordConfirmer.instance = new PasswordConfirmer();
    return PasswordConfirmer.instance;
  }
}

export default PasswordConfirmer;



/** WEBPACK FOOTER **
 ** ./src/app/directives/formValidators/passwordConfirmer.js
 **/